module.exports = __webpack_public_path__ + "img/arduino.7c27041a.png";